// API Endpoints Constants
export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: "/api/auth/login",
    REGISTER: "/api/auth/register",
    FORGOT_PASSWORD: "/api/auth/forgot-password",
    RESET_PASSWORD: "/api/auth/reset-password",
    LOGOUT: "/api/auth/logout",
    VERIFY_TOKEN: "/api/auth/verify",
  },

  // Lawyer endpoints
  LAWYERS: {
    GET_ALL: "/api/lawyers",
    GET_BY_ID: "/api/lawyers",
    UPDATE_ROLE: "/api/lawyers/update-role",
    DELETE: "/api/lawyers/delete",
    ASSIGN_CLIENT: "/api/lawyers/assign-client",
    REMOVE_CLIENT: "/api/lawyers/remove-client",
  },

  // Client endpoints
  CLIENTS: {
    GET_ALL: "/api/clients",
    GET_BY_ID: "/api/clients",
    CREATE: "/api/clients/create",
    UPDATE: "/api/clients/update",
    DELETE: "/api/clients/delete",
    CREATE_UPDATE: "/api/clients/upload-client-data",
  },

  // File/Slide endpoints
  FILES: {
    UPLOAD: "/api/uploads/multiple",
    GET_SIGNED_URL: "/api/uploads/get-signed-url",
  },
};

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  HEADERS: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
  },
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: "token",
  USER: "user",
  AUTH_TOKEN: "authToken", // Alternative token key used in some parts
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};
